<script>
    import { onMount } from 'svelte';
    import { fetchLeagues } from '/public/services/games.js';

    let lgs = null;
    let loading = true;


    function loadLeagues() {
        fetchLeagues().then(res => {
            if (res.success) {
                lgs = res.data.leagues;

                loading = false;
            }
        });
    }

    onMount(() => {
        loadLeagues();
    });

</script>
<div class="vw-100 mb-5">
    <div class="row justify-content-center">
        <div class="col-sm-12 col-md-10 col-lg-8">
            <div class="card w-auto mt-5 mb-5">
                <div class="card-header">
                    <span class='fas fa-volleyball-ball'></span> Welcome
                </div>
                <div class="card-body">

                    {#if loading === true}

                        <div class='text-center mt-5 mb-5'>
                            <h4>
                                <span class='ajax-ball-loader'></span> Fetching Social Leagues....
                            </h4>
                        </div>

                    {:else}

                        {#if lgs.length == 0}

                            <p class='mt-5 mb-5'>
                                <span class='fas fa-info-circle'></span> Sorry, we have no Leagues to show you at this time.
                            </p>

                        {:else}

                            <div class='clearfix mb-3'>
                                <img src='/images/ScorpsLogo.png' class='img-responsive float-start me-2 scorps-logo' alt='Scorpions Logo'/>
                                <h1 class='m-0'>
                                    Choose your League:
                                </h1>
                            </div>

                            <div class='list-group'>

                                {#each lgs as l}

                                    <div class='list-group-item'>
                                        <div class='row'>
                                            <div class='col-sm-2'>
                                                <div class='d-grid'>

                                                    {#if l.multi === false}

                                                        <a href='#/l/{ l.id }' class='btn btn-primary'>
                                                            <span class='fas fa-chevron-right'></span>
                                                        </a>

                                                    {:else}

                                                        <a href='#/m/{ l.id }' class='btn btn-primary'>
                                                            <span class='fas fa-chevron-right'></span>
                                                        </a>

                                                    {/if}

                                                </div>
                                            </div>
                                            <div class='col-sm-10'>
                                                <h3 class=''>

                                                    { l.name }

                                                </h3>

                                                {#if l.multi === false}

                                                    <div class='text-end'>

                                                        <h5>

                                                            <span class='fas fa-clock text-secondary'></span> { l.day } <span class='fas fa-school text-secondary'></span> { l.venue }

                                                        </h5>

                                                    </div>

                                                {:else}

                                                    {#each l.venues as v}

                                                        <div class='text-end'>

                                                            <h5>
                                                                <span class='fas fa-clock text-secondary'></span> { v.day } <span class='fas fa-school text-secondary'></span> { v.name }
                                                            </h5>

                                                        </div>

                                                    {/each}

                                                {/if}

                                            </div>
                                        </div>
                                    </div>

                                {/each}

                            </div>

                        {/if}
                    
                        

                    {/if}

                </div>
            </div>   
        </div>
    </div>
</div>

<style>
    .scorps-logo {
      width: 50px;
      height: 50px;
    }
</style>